import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        userSkill: '<'
    },
    template: `
        <div class="scale">
            <div style="width: 20px;">{{ vm.userSkill.proficiency.points }}</div>
            <div class="bar" ng-class="{ 'animate': vm.animateBars }">
                <span
                    class="marker"
                    style="left: {{ vm.getProficiencyPercentage(
                        vm.userSkill.requiredProficiency.points,
                        vm.getMaxProficiencyPoints(vm.userSkill.skill.scale.proficiencies)
                    ) }}">
                    {{ vm.getMaxProficiencyPoints(vm.userSkill.skill.scale.proficiencies) }}
                </span>
                <span
                    class="fill {{ vm.getStatusClass(vm.userSkill.proficiency.points, vm.userSkill.requiredProficiency.points) }}"
                    data-skill-id="{{ vm.userSkill.id }}"
                    ng-style="{ width: vm.getProficiencyPercentage(vm.userSkill.proficiency.points, vm.getMaxProficiencyPoints(vm.userSkill.skill.scale.proficiencies)) }">
                </span>
            </div>
            <span
                class="tooltip-icon"
                ng-if="vm.getSkillExplanation(vm.userSkill.skill, vm.userSkill.proficiencyId)"
                tooltip-append-to-body="true"
                uib-tooltip="{{ vm.getSkillExplanation(vm.userSkill.skill, vm.userSkill.proficiencyId) }}"
                tooltip-placement="right">i</span>
        </div>
        <style>
            .bar {
                margin-left: 3px;
            }
            .bar .marker {
                transition: left 0.8s cubic-bezier(0.34, 1.56, 0.64, 1)!important;
                z-index: 2;
            }
            .bar .fill {
                transition: width 1s cubic-bezier(0.25, 1.5, 0.5, 1), background-color 0.5s ease!important;
                transform-origin: left center!important;
            }
        </style>
    `
})
export default class {
    constructor (I18nService) {
        this.I18nService = I18nService;
        this.explanation = null;
    }

    getSkillExplanation (skill, proficiencyId) {
        if (!skill || !Array.isArray(skill.explanations)) return null;

        const explanation = skill.explanations.find(
            e => e.proficiencyId === proficiencyId
        );

        if (explanation && explanation.i18ns !== undefined) {
            this.explanation = this.getTranslation(skill, explanation.i18ns);
            if (!this.explanation) return null;
            return `${explanation.proficiency.points} - ${this.explanation}`;
        }

        return null;
    }

    getMaxProficiencyPoints (proficiencies) {
        if (!Array.isArray(proficiencies) || proficiencies.length === 0) return 0;
        return Math.max(...proficiencies.map(p => p.points || 0));
    }

    getProficiencyPercentage (points, maxPoints) {
        if (!maxPoints || maxPoints <= 0) return '0%';
        const percent = (points / maxPoints) * 100;
        return `${Math.min(Math.round(percent), 100)}%`;
    }

    getStatusClass (points, requiredPoints) {
        if (points >= requiredPoints) {
            return 'status02';
        }
        return 'status01';
    }

    getTranslation (skill, explantionI18ns) {
        const i18n = this.I18nService.getPreferredI18n(skill.i18ns);
        if (!i18n || !explantionI18ns) {
            return null;
        }

        const lang = i18n.language;
        const activeExplanation = explantionI18ns[lang] ? explantionI18ns[lang] : null;

        return activeExplanation && activeExplanation.value
            ? activeExplanation.value : null;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/skill/user/bar/index.js